<ng-template #frameModal>
  <div class="frame-content" id="frame-modal">
    <div class="modal-header p-2 header-panel">
      <div class="d-flex align-items-center flex-wrap p-2 border-header">
        <div class="d-none d-lg-flex align-items-center m-3">
          <em class="fa fa-wifi fa-2x text-white"></em>
        </div>
        <div class="line bg-white d-none d-lg-flex"></div>
        <div class="text-left ml-2">
          <div class="flex-column">
            <h2 class="mb-0 d-flex align-items-start">
              {{ "alerts.general.testing-device" | translate }}
              <span
                class="badge badge-light c-pointer help-badge"
                placement="bottom"
                ngbTooltip="{{ 'tooltip.test-device' | translate }}."
                >?</span
              >
            </h2>
            <p class="m-0">{{ "frames-device-dynamic.request-commands" | translate }}</p>
          </div>
        </div>
      </div>

      <h3 class="m-0 c-pointer" (click)="closeModal()">&times;</h3>
    </div>
    <div class="w-100 text-center mt-2">
      <p class="mb-0 font-11">
        <b>{{ "alerts.general.subtitle-device" | translate }}.</b>
      </p>
    </div>

    <div class="row">
      <div class="col-12">
        <form [formGroup]="filters">
          <div class="row m-0">
            <div class="col-12 col-md-6 col-lg-4 col-xl-4">
              <small>{{ "filter.status" | translate }}</small>
              <select
                class="form-control"
                name="statusFeeders"
                id="statusFeeders"
                formControlName="status"
              >
                <option value="">{{ "general.all" | translate }}</option>
                <option value="error">{{ "filter.error" | translate }}</option>
                <option value="done">{{ "filter.done" | translate }}</option>
                <option value="loading">{{ "filter.loading" | translate }}</option>
              </select>
            </div>
            <!--    <div class="col-12 col-md-6 col-lg-4 col-xl-4">
              <small>{{ "filter.pond" | translate }}</small>
              <select
                class="form-control"
                name="pondSelected"
                id="pondSelected"
                formControlName="pond"
              >
                <option value="">{{ "general.all" | translate }}</option>
                <option *ngFor="let pond of []" [value]="pond.id">
                  {{ pond.name }}
                </option>
              </select>
            </div> -->
            <div class="col-12 col-md-6 col-lg-4 col-xl-4">
              <small>{{ "filter.name" | translate }}</small>
              <input class="form-control" type="search" formControlName="name" name="name" />
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="content-frames">
      <div class="menu scroll-container">
        <div *ngFor="let menu of deviceMenu;let idxmenu = index;">
          <div class="buttons">
            <button
              type="button"
              class="btn btn-testing mt-2"
              (click)="clickButtonMenu(menu,idxmenu)"
              [class]="menu.validateStatus(menu,temporal_devices).btn"
            >
              <p class="button-label">{{menu.label | translate}}</p>
              <img
                *ngIf="menu.icon"
                [src]="'assets/img/icons/' + menu.icon"
                width="20"
                [alt]="menu.label"
              />

              <p class="m-0 ml-1">
                ( {{menu.countSatus(menu,temporal_devices,'done')}} / {{
                menu.countSatus(menu,temporal_devices) }} )
              </p>
            </button>
            <div
              class="spinner-border text-secondary spinner-menu fa-nx ml-2 mr-1 margin-icon-menu"
              *ngIf="menu.validateStatus(menu,temporal_devices).type === 1"
              style="height: 1rem; width: 1rem"
              role="status"
            ></div>
            <i
              *ngIf="menu.validateStatus(menu,temporal_devices).type !== 1"
              class="fa fa-nx ml-2 mr-1 margin-icon-menu"
              [class]="menu.validateStatus(menu,temporal_devices).check"
              aria-hidden="true"
            ></i>
          </div>
        </div>
      </div>
      <div class="frames">
        <div *ngFor="let device of temporal_devices">
          <h5>
            {{device.name}}
            <em
              class="fa fa-question-circle c-pointer fa-1x mr-2"
              [style.color]="'#7a847c'"
              placement="top"
              [ngbPopover]="infoAlert"
              container="body"
              triggers="mouseenter:mouseleave"
              *ngIf="globalFunction.validateSoloAdmin()"
            ></em>
          </h5>

          <ng-template #infoAlert>
            <div class="pop-info">
              <div *ngIf="device.hasOwnProperty('mac') ">
                <p class="m-0">Mac: {{device.mac}}</p>
              </div>

              <div *ngIf="device.hasOwnProperty('lat') && device.hasOwnProperty('lng')">
                <p class="m-0">Lat:{{device.lat}}</p>
                <p class="m-0">Lng:{{device.lng}}</p>
              </div>
              <div
                *ngIf="device.hasOwnProperty('version') && !device.hasOwnProperty('emptied') && globalFunction.validateSoloAdmin()"
              >
                <p class="m-0">Version:{{device.version}}</p>
              </div>
            </div>
          </ng-template>

          <div
            *ngFor="let menu of deviceMenu"
            class="alert-card"
            [ngClass]="{'d-none': device.device_status[menu.type_frame].status === ''}"
            [class]="validateAlertColor(menu,device)"
          >
            <div *ngIf="device.device_status[menu.type_frame].status === 'done'">
              <app-view-device
                [menu]="menu"
                [device]="device"
                (individualPetition)="individualPetition($event)"
              ></app-view-device>
            </div>
            <div *ngIf="device.device_status[menu.type_frame].status === 'loading'">
              <app-loading-device [menu]="menu" [device]="device"></app-loading-device>
            </div>
            <div *ngIf="device.device_status[menu.type_frame].status === 'error'">
              {{device.device_status[menu.type_frame].failReason}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
